const cancelationReason = {
  cancelationReason: 'Cancelation Reason',
  addCancelationReason: 'Add Cancelation Reason',
  editCancelationReason: 'Edit Cancelation Reason',
};
export default cancelationReason;
